<template>
  <div class="contain">
    <!-- 头部 -->
    
    <headerHtml></headerHtml>
    <!-- 中间大图 -->
    <el-main class="banner">
      <el-carousel :interval="5000">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <el-image class="banner-img" :src="item.imgSrc"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-main>
    <!-- 中间主要内容 -->
    <el-main class="main">
      
      <div class="main-contain">
        <!-- 交易数据 -->
        <div class="sales">
			<div class="sales-li">
			  <div>
			    <div class="num">{{ Math.floor(sjzbObj.steelConcentratePurAmt) }} <span class="unit">亿元</span></div>
			    <div class="describe">集采平台交易额</div>
			  </div>
			</div>
          <div class="sales-li">
            <div>
              <div class="num">{{ Math.round(sjzbObj.purchaseAmounts) }} <span class="unit">亿元</span></div>
              <div class="describe">招标交易额</div>
            </div>
          </div>
          <div class="sales-li">
            <div>
              <div class="num">{{ Math.round(sjzbObj.openPurchaseAmounts) }} <span class="unit">亿元</span></div>
              <div class="describe">比选交易额</div>
            </div>
          </div>
          <!-- <div class="sales-li">
            <div>
              <div class="num">{{ sjzbObj.mallAmounts }} <span class="unit">亿元</span></div>
              <div class="describe">首钢商城年交易额</div>
            </div>
          </div> -->
          <div class="sales-li">
            <div>
              <div class="num">{{ Math.round(sjzbObj.commodityQty) }} <span class="unit">万件</span></div>
              <div class="describe">商城商品数量</div>
            </div>
          </div>
          <div class="sales-li">
            <div>
              <div class="num">{{ sjzbObj.merchantQty }} <span class="unit">家</span></div>
              <div class="describe">合作商数量</div>
            </div>
          </div>
        </div>
        <!-- 详情 -->
        <div class="mokuai">
          <div class="mokuai-li ptjs">
            <div class="mokuai-li-title">
              <img src="@/assets/img/js.png" alt="">
              <span class="title-name">功能介绍</span> 
              <!-- <span class="title-more">更多>></span> -->
            </div>
            <div class="mokuai-li-main">
              <div class="ptjs-tab">
                
                <div @click="tabclick(1)" class="tabli" :class="tabKey.tag==1?'active':''">首钢招标</div>
                <div @click="tabclick(2)" class="tabli" :class="tabKey.tag==2?'active':''">首钢比选</div>
                <div @click="tabclick(3)" class="tabli" :class="tabKey.tag==3?'active':''">首钢商城</div>
              </div>
              <div v-if="tabKey.tag==3" >
                <div class="ptjs-img">
                  <img class="ptjs-img-img" src="@/assets/img/SCZC.png" style="" alt="">
                  <ul>
                    <li><img :src="imgSrc.png1" alt=""></li>
                    <li><img src="@/assets/img/hzbf5.png" alt=""></li>
                    <li><img src="@/assets/img/hzbf.png" alt=""></li>
                    <li><img src="@/assets/img/hzbf2.png" alt=""></li>
                    <li><img src="@/assets/img/jy.png" alt=""></li>
                  </ul>
                </div>
                <el-steps :active="5" align-center >
                  <el-step title="战略合作" description=""></el-step>
                  <el-step title="商城上架" description=""></el-step>
                  <el-step title="用户下单" description=""></el-step>
                  <el-step title="商城送货" description=""></el-step>
                  <el-step title="商城结算" description=""></el-step>
                </el-steps>
              </div>
              
              <div v-if="tabKey.tag==1" >
                <div class="ptjs-img">
                  <img  class="ptjs-img-img" src="@/assets/img/GZPT.png" style="" alt="">
                  <ul>
                    <li><img src="@/assets/img/hz.png" alt=""></li>
                    <li><img src="@/assets/img/wz.png" alt=""></li>
                    <li><img src="@/assets/img/ws.png" alt=""></li>
                    <li><img src="@/assets/img/bf.png" alt=""></li>
                    <li><img src="@/assets/img/jy.png" alt=""></li>
                  </ul>
                </div>
                <el-steps :active="5" align-center >
                  <el-step title="提报计划" description=""></el-step>
                  <el-step title="公开招标" description=""></el-step>
                  <el-step title="签约" description=""></el-step>
                  <el-step title="执行" description=""></el-step>
                  <el-step title="结算" description=""></el-step>
                </el-steps>
              </div>

              <div v-if="tabKey.tag==2" >
                <div class="ptjs-img">
                  <img  class="ptjs-img-img" src="@/assets/img/BXPT.png" style="" alt="">
                  <ul>
                    <li><img src="@/assets/img/hz.png" alt=""></li>
                    <li><img src="@/assets/img/DN.png" alt=""></li>
                    <li><img src="@/assets/img/ws.png" alt=""></li>
                    <li><img src="@/assets/img/bf.png" alt=""></li>
                    <li><img src="@/assets/img/jy.png" alt=""></li>
                  </ul>
                </div>
                <el-steps :active="5" align-center >
                  <el-step title="提报计划" description=""></el-step>
                  <el-step title="邀请询价" description=""></el-step>
                  <el-step title="签约" description=""></el-step>
                  <el-step title="执行" description=""></el-step>
                  <el-step title="结算" description=""></el-step>
                </el-steps>
              </div>
            </div>
          </div>
          <div class="mokuai-li xwzx">
            <div class="mokuai-li-title">
              <img src="@/assets/img/zxxw.png" alt="">
              <span class="title-name">新闻资讯</span> <span @click="moreClick(1)" class="title-more">更多>></span>
            </div>
            <div class="mokuai-li-main">
              <ul >
                <!-- <li v-for="(item,index) in news.slice(0,4)"> -->
                <li v-for="(item,index) in newsList.slice(0,4)">
                  
                  <div class="date">
                    <p class="day">{{item.date.slice(8,10)}}</p>
                    <p class="year">{{item.date.slice(0,7)}}</p>
                  </div>
                  <div class="text" @click="newsClick(item,index)" style="cursor: pointer;">
                    <p class="text-overflow fb fs14" :title="item.name"> {{ item.name }}</p>
                    <p class="text-overflow" :title="item.first.slice(0,34)">{{item.first.slice(0,34)}}</p>
                  </div>
                </li>
                
              </ul>

            </div>
          </div>
          <div class="mokuai-li cggg">
            <div class="mokuai-li-title">
              <img src="@/assets/img/gg.png" alt="">
              <span class="title-name">采购公告</span> <span @click="moreClick(2)" class="title-more">更多>></span>
            </div>
            <div class="mokuai-li-main" style="padding:0;background:none;">

              <div class="queryview1">
                <div class="queryview1-top">
                  <div class="queryview1-link" :class="queryactive==1?'active':''" @click="queryitem1(1)">
                    招标公告
                  </div>
                  <div class="queryview1-link" :class="queryactive==2?'active':''" @click="queryitem1(2)">
                    比选公告
                  </div>
                </div>
                <div class="queryview1-cent">
                  <div class="query1-neirong" v-if="queryactive==1">
                    
                    <ul> 
                      <li class="cggg-li" v-for="(item,index) in noticeList.slice(0,5)">
                        <p @click="noticeClick(item,index)" :title="item.name">{{item.name}}</p>
                        <span :class="item.status == '已截止'?'statusStrGrey':''" class="statusStr">{{item.status}}</span>
                        <span class="dateStr">{{item.date != null ? item.date.slice(0,10) : ''}}</span>
                      </li>
                      <!-- <li class="cggg-li">
                        <a href="#">采购公告内容采购公告内容公告内容采…</a>
                        <span class="statusStr">已发布</span>
                        <span class="dateStr">2024.12.04</span>
                      </li>
                      <li class="cggg-li">
                        <a href="#">采购公告内容采购公告内容公告内容采…</a>
                        <span class="statusStr">已发布</span>
                        <span class="dateStr">2024.12.04</span>
                      </li>
                      <li class="cggg-li">
                        <a href="#">采购公告内容采购公告内容公告内容采…</a>
                        <span class="statusStr">已发布</span>
                        <span class="dateStr">2024.12.04</span>
                      </li>
                      <li class="cggg-li">
                        <a href="#">采购公告内容采购公告内容公告内容采…</a>
                        <span class="statusStr">已发布</span>
                        <span class="dateStr">2024.12.04</span>
                      </li>
                      <li class="cggg-li">
                        <a href="#">采购公告内容采购公告内容公告内容采…</a>
                        <span class="statusStr">已发布</span>
                        <span class="dateStr">2024.12.04</span>
                      </li> -->
                    </ul>
                  </div>
                  <div class="query1-neirong" v-if="queryactive==2">
                    <ul> 
                      <li class="cggg-li" v-for="(item,index) in bxgglist.slice(0,5)">
                        <p :title="`${item.inquiryTitle}`" style="width:320px;cursor:unset;cursor:pointer;" @click="bxggclick(item)">{{item.inquiryTitle}}</p>
                        <span class="dateStr">{{item.inquiryReleaseTime != null ? item.inquiryReleaseTime.slice(0,10) : ''}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mokuai-li shangcheng">
            <div class="mokuai-li-title">
              <img src="@/assets/img/gw.png" alt="">
              <span class="title-name">专享商城</span> 
              <!-- <span class="title-more">更多>></span> -->
            </div>
            <div class="mokuai-li-main ZXSC" style="height: 62px;">
              <img style="height: 48px;width: 100%;" src="@/assets/img/goods.png" alt="">
            </div>
            <div class="mokuai-li-title">
              <img src="@/assets/img/fz.png" alt="">
              <span class="title-name">合作电商</span> 
              <!-- <span class="title-more">更多>></span> -->
            </div>
            <div class="mokuai-li-main hzds">
              <!-- 轮播 -->
              <div class="lunbo">
                <div class="lunboLeft">
                  <ul class="lbleft">
                    <li :class="lunboConfig.showCount == index ? 'lunboLeftHover':'a'" v-for="(item,index) in hzdsData" :key="index" @mouseenter="enterMouse(index)" @mouseleave="leaveMouse(index)"  >
                      <img :style="{'display':(lunboConfig.showCount == index ? 'block' : 'none') }" class="rightJt" src="@/assets/img/right.png" alt="" />
                      <!-- 下面a标签超链接属性暂时去掉  :href="item.linkUrl" -->
                      <a :style="{'display':(lunboConfig.showCount == index ? 'block' : 'none'),'background-image':'url('+item.logourl_on+'?width=97'+')' }" target="_blank"></a>
                      <a :style="{'display':(lunboConfig.showCount == index ? 'none' : 'block'),'background-image':'url('+item.logourl+'?width=97'+')' }" target="_blank"></a>
                    </li>
                  </ul>
                </div>
                <div class="lunboRight">
                  <ul class="lbright" :style="{'marginLeft':''+(-(screenWidth > 1520?393:303)*lunboConfig.imgCount)+'px','transition':(lunboConfig.imgCount == 0 ? '0s' : '0.5s')}">
                    <li :style="{'background-image':'url('+item.imageUrl+')' }" @mouseenter="enterMouse(index)" @mouseleave="leaveMouse(index)" v-for="(item,index) in hzdsDataAdd" :key="index"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mokuai-li ryq">
            <div class="mokuai-li-title">
              <img src="@/assets/img/jb.png" alt="">
              <span class="title-name">荣誉墙</span> 
              <!-- <span class="title-more">更多>></span> -->
            </div>
            <div class="mokuai-li-main ">
              <!-- <img src="" alt=""> -->
              <el-carousel :interval="4000" type="card" height="228px" width="100%">
                <el-carousel-item v-for="item in ryList" :key="item">
                  <el-image class="banner-img" :src="item.imgSrc"></el-image>
                </el-carousel-item>
              </el-carousel>
              <!-- <img src="@/assets/img/ryq.png" alt="" /> -->
            </div>
          </div>
          <div class="mokuai-li qyhl">
            <div class="mokuai-li-title">
              <img src="@/assets/img/hl.png" alt="">
              <span class="title-name">企业互联</span> 
              <!-- <span class="title-more">更多>></span> -->
            </div>
            <div class="mokuai-li-main">
              <div class="qy">
                <div class="jianjie shanjiao">
                  <div class="text1">
                    <p>山焦集团</p>
                  </div>
                  <!-- <div class="text2">
                    <span class="text2-title">山焦集团</span>
                    <span class="text2-content">相关文字介绍在此显示相关文字介绍在此显示...</span>
                    <span class="text2-more">查看详情>></span>
                  </div> -->
                </div>
                <div class="jianjie kailuan">
                  <div class="text1"><p>开滦集团</p>
                  </div>
                  <!-- <div class="text2">
                    <span class="text2-title">山焦集团</span>
                    <span class="text2-content">相关文字介绍在此显示相关文字介绍在此显示...</span>
                    <span class="text2-more">查看详情>></span>
                  </div> -->
                </div>
                <div class="jianjie shanneng">
                  <div class="text1"><p>山能集团</p>
                  </div>
                  <!-- <div class="text2">
                    <span class="text2-title">龙煤集团</span>
                    <span class="text2-content">相关文字介绍在此显示相关文字介绍在此显示...</span>
                    <span class="text2-more">查看详情>></span>
                  </div> -->
                </div>
              </div>
                <p class="btText">用数字化手段，提升企业核心竞争力，实现企业互联</p>
            </div>
          </div>
        </div>

        <!-- 公司 -->
        <div class="company">
          <div class="company-li" style="background: #579EFA;" @click="jumpCompany(1)">
            <div class="company-li-logo">
              <img src="@/assets/img/logo1.png" alt="" />
            </div>
            <div class="company-li-describe" >
              <span>首钢集团</span><br/>
              <span class="trans">SHOUGANG GROUP</span>
            </div>
          </div>
          <div class="company-li" style="background: #7A88FA;" @click="jumpCompany(2)">
            <div class="company-li-logo">
              <img src="@/assets/img/logo1.png" alt="" />
            </div>
            <div class="company-li-describe">
              <span>首钢股份</span><br/>
              <span class="trans" style="transform: scale(0.76413);">BEIJING SHOUGANG CO .,LTD</span>
            </div>
          </div>
          <div class="company-li" style="background: #3DD88F;" @click="jumpCompany(3)">
            <div class="company-li-logo">
              <img src="@/assets/img/logo1.png" alt="" />
            </div>
            <div class="company-li-describe">
              <span>首钢京唐</span><br/>
              <span class="trans" style="transform: scale(0.726087);">SHOUGANG JINGTANG STEEL CO., LTD</span>
            </div>
          </div>
          <!-- <div class="company-li" style="background: #FE9961;" @click="jumpCompany(4)">
            <div class="company-li-logo">
              <img src="@/assets/img/logo1.png" alt="" />
            </div>
            <div class="company-li-describe">
              <span>首钢比选采购平台</span><br/>
              <span class="trans" style="transform: scale(0.51087);">SHOUGANG SUPPLY CHAIN COLLABORATION PLATFORM</span>
            </div>
          </div> -->
          <div class="company-li" style="background: #579EFA;" @click="jumpCompany(5)">
            <div class="company-li-logo">
              <img src="@/assets/img/logo1.png" alt="" />
            </div>
            <div class="company-li-describe">
              <span>首钢供应链金融</span><br/>
              <span class="trans" style="transform: scale(0.71087);">SHOUGANG SUPPLY CHAIN FINANCE</span>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    
    <!-- 底部 -->
    <footerHtml></footerHtml>
  </div>
</template>
<script>
import { computed, ref, watch, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import { useRoute,useRouter  } from "vue-router";

export default {
  components: {

  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const activeTab = ref("first");
    

    

    return {
      route,
      store,
      activeTab,
    };
  },
};
</script>
<script  setup>
  import { news } from "@/views/components/news";
  import { notice } from "@/views/components/notice";
  import headerHtml from "@/views/components/headerHtml";
  import footerHtml from "@/views/components/footerHtml";
  // 查询的ajax请求
	import queryApi from "@/utils/request";

  let newsList = reactive([]);
  let noticeList = reactive([]);
  let sjzbObj = reactive({
    mallAmounts:2.97,//商城交易额
    merchantQty:620,//合作数量
    openPurchaseAmounts:12.09,//公开比选
    purchaseAmounts:15.49,//招标采购
    commodityQty:56.35,//商品数量
  });
  //顶部轮播假数据
  let bannerList= reactive([{
    imgSrc:require('@/assets/img/bg0.png')
  },{
    imgSrc:require('@/assets/img/bg1.png')
  },{
    imgSrc:require('@/assets/img/bg2.png')
  },{
    imgSrc:require('@/assets/img/bg3.png')
  },{
    imgSrc:require('@/assets/img/bg4.png')
  }])
  // 轮播假数据
  let hzdsData = [
      {
        "title": "京东",
        "linkUrl": "https://www.jingdong.com/",
        "logourl": require('@/assets/img/jdS.jpg'),
        "logourl_on": require('@/assets/img/jdS.jpg'),
        "imageUrl": require('@/assets/img/jsL.png')
      },
      {
        "title": "欧贝",
        "linkUrl": "https://www.obei.com/",
        "logourl": require('@/assets/img/obS.png'),
        "logourl_on": require('@/assets/img/obS.png'),
        "imageUrl": require('@/assets/img/obL.jpg')
      },
      // {
      //   "title": "万物集",
      //   "linkUrl": "https://www.grainger.cn/",
      //   "logourl": "http://csxt.sggfzx.com:8080/upload/cms/image/16879213551942.png",
      //   "logourl_on": "http://csxt.sggfzx.com:8080/upload/cms/image/16879213656802.png",
      //   "imageUrl": "http://csxt.sggfzx.com:8080/upload/cms/image/16879215116142.png"
      // },
      // {
      //   "title": "艾逊",
      //   "linkUrl": "http://www.axmro.com/",
      //   "logourl": "http://csxt.sggfzx.com:8080/upload/cms/image/16092306517233.png",
      //   "logourl_on": "http://csxt.sggfzx.com:8080/upload/cms/image/16092306570793.png",
      //   "imageUrl": "http://csxt.sggfzx.com:8080/upload/cms/image/15973830369291.jpg"
      // },
      // {
      //   "title": "鑫方盛",
      //   "linkUrl": "https://www.fsyuncai.com/",
      //   "logourl": "http://csxt.sggfzx.com:8080/upload/cms/image/16109492007693.png",
      //   "logourl_on": "http://csxt.sggfzx.com:8080/upload/cms/image/16109381872961.png",
      //   "imageUrl": "http://csxt.sggfzx.com:8080/upload/cms/image/16103286050792.jpg"
      // }
  ]
  //荣誉轮播假数据
  let ryList= reactive([{
    imgSrc:require('@/assets/img/ry1.jpg')
  },{
    imgSrc:require('@/assets/img/ry2.png')
  },{
    imgSrc:require('@/assets/img/ry3.jpg')
  },{
    imgSrc:require('@/assets/img/ry4.jpg')
  },{
    imgSrc:require('@/assets/img/ry5.jpg')
  },{
    imgSrc:require('@/assets/img/ry6.jpg')
  }])
  // 图片路径数据 
  let imgSrc = reactive({
    
    png1:require('@/assets/img/hzbf1.png')
  })
  let tabKey = reactive({
		tag:1
	});
  const tabclick = (key) => {
    // console.log(tabKey,key)
    tabKey.tag = key;
  }

  //获取可是宽度
  const screenWidth = window.screen.width;
  
  const router = useRouter();
  const moreClick = (key) => {
    if(key == 1){
      
      const { href } = router.resolve({
        name: 'news'
      })
      window.open(href, '_blank');
    }else if(key == 2){
      
      const { href } = router.resolve({
        name: 'notice'
      })
      if(queryactive.value==1){
        window.open(href, '_blank');
      }else{
        window.open('https://www.sggylpt.com/static/purchaser/homePage/html-gulp-www/systemBulletin.html', '_blank');
      }
    }
    
  }
  const newsClick = (item,index) => {
   
      // router.push({
      //   path:"/newsContent",
      //   query:{
      //     index:index,
      //   }
      // })
      const { href } = router.resolve({
        name: 'newsContent',
        query:{
          index:index,
          content:item.content,
          title:item.name,
          date:item.date,
        }
      })
      window.open(href, '_blank');
  }
  const noticeClick = (item,index) => {
    
    // router.push({
    //   path:"/noticeContent",
    //   query:{
    //     index:index,
    //   }
    // })
    const { href } = router.resolve({
        name: 'noticeContent',
        query:{
          index:index,
          content:item.content,
          title:item.name,
          date:item.date,
        }
      })
      window.open(href, '_blank');
  }
  // 底部公司跳转
  const jumpCompany = (index) => {
    let companyLink = [
      "https://www.shougang.com.cn",
      "https://www.sggf.com.cn",
      "https://www.sgjtsteel.com",
      "https://www.sggylpt.com",
      "https://www.shouganggyl.com",
    ]
    window.open(companyLink[index-1])
  }

  // 轮播
  
  let lunboConfig = reactive({
    time1: 0,
    showCount: 0,
    imgCount: 0,
  })
  let hzdsDataAdd = [].concat(hzdsData)
  // addArr = addArr.slice(0,4)
  hzdsDataAdd.push(hzdsDataAdd[0])
  let timer = () => {
    lunboConfig.showCount++;
    lunboConfig.imgCount++;
    lunboConfig.showCount = lunboConfig.showCount%4;
    lunboConfig.imgCount = lunboConfig.imgCount%5;
    if(lunboConfig.imgCount == 4){
      setTimeout(()=>{
        lunboConfig.imgCount = 0;
      },1000)
    }
  }
  let enterMouse = (index) => {
    if(index == 4){
      lunboConfig.showCount = 0;
    } else {
      lunboConfig.showCount = index;
    }
    lunboConfig.imgCount = index
    clearInterval(lunboConfig.time1);
  }
  let leaveMouse = (index) => {
    lunboConfig.time1 = setInterval(lunboConfig.timer,2000);
  }



  let bxggclick = (item)=>{
    window.open('https://www.sggylpt.com/static/purchaser/homePage/html-gulp-www/purchaserOrganize.html?id='+item.id, '_blank');
  }

  onMounted(() => {
    // cms调用接口
    const url = "/ms/parseArticle/findPageResult";
    // 新闻资讯
    let param = {"fileKey":"/upload/cms/column/mhxwzx/index.html","title":"","start":0,"limit":4};
    queryApi({url: url, data:param }, "post").then(res => {
      let data =  res.rows.rows[0].rows;
      data.forEach(item => {
        newsList.push({
            name:item.title,
            date:item.datetime,
            first:item.simple,
            content:item.content
        })
      });
    })

    //采购公告
    let param1 = {"fileKey":"/upload/cms/column/mhcggg/index.html","title":"","start":0,"limit":6};
    queryApi({url: url, data:param1 }, "post").then(res => {
      let data =  res.rows.rows[0].rows;
      data.forEach(item => {
        noticeList.push({
            name:item.title,
            date:item.datetime,
            status:item.status,
            content:item.content
        })
      });
    })









    //比选公告
    queryApi({url: '/wwwapi/front/getlatest', data:{"reqHeader":{"operTitle":""},"reqBody":{}} }, "post").then(res => {
      bxgglist.value = res.rspBody;
    })



    // 数据指标
    let param2 = {"fileKey":"/upload/cms/column/mhsj/index.html","title":"","start":0,"limit":5}
    queryApi({url: url, data:param2 }, "post").then(res => {
      
      if(res.rows && res.rows.respCode == "0000"){
        // sjzbObj
        let data = res.rows.rows[0].rows[0];
        if(data){
          sjzbObj.mallAmounts=data.mall_amounts//商城交易额
          sjzbObj.merchantQty=data.merchant_qty//合作数量
          sjzbObj.openPurchaseAmounts=data.open_purchase_amounts//公开比选
          sjzbObj.purchaseAmounts=data.purchase_amounts//招标采购
          sjzbObj.commodityQty=data.commodity_qty//商品数量
		  sjzbObj.steelConcentratePurAmt=data.steel_concentrate_pur_amt//首钢钢铁板块集采交易额
        }
        
      }
      
    })
  });



  let bxgglist = ref([]);
  let queryactive = ref(1);
  let queryitem1 = (params)=>{
    queryactive.value = params;
  }

</script>
<style lang="scss" scoped>

.fb{
  font-weight: 900;
}
.fs14{
  font-size: 14px;
}

.contain {
  width: 100%;
  height: 100%;
  overflow-y: auto!important;
}
.headerHtml{
  height: 100px;
  
  // background-color: #fff;
  // background-image: url("@/assets/img/logo.png");
  // background-size: 210px 49px;
  // background-repeat: no-repeat;
  // background-position: 9.78% 30px;
}
.headerCol{
  text-align: center;
}
.headerLi{
  
  height: 100px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  cursor: pointer;
}

.headerLi .imgIcon{
  height: 24px;
  width: 24px;
}
.headerLi .nameText{
  font-weight: bold;
  font-size: 24px;
  color: #000;
  line-height: 36px;
  text-align: left;
  font-style: normal;
}
.headerLi .imgIcon{
  background-size: 100%;
  background-repeat: no-repeat;
  margin-right: 10px;
}
.headerHome .imgIcon{
  background-image: url("@/assets/img/home.png");
}
.headerZX .imgIcon{
  background-image: url("@/assets/img/zx.png");
}
.headerSC .imgIcon{
  background-image: url("@/assets/img/gwc.png");
}
.headerZC .imgIcon{
  background-image: url("@/assets/img/leixing.png");
}
.headerLi:hover{
  background: #0475D7;
}
.headerLi:hover .nameText{
  color: #FFFFFF;
}
.headerLi:hover{
  background: #0475D7;
}
.headerLi.headerHome:hover .imgIcon{
  background-image: url("@/assets/img/home1.png");
}
.headerLi.headerZX:hover .imgIcon{
  background-image: url("@/assets/img/zx1.png");
}
.headerLi.headerSC:hover .imgIcon{
  background-image: url("@/assets/img/gwc1.png");
}
.headerLi.headerZC:hover .imgIcon{
  background-image: url("@/assets/img/leixing1.png");
}
.headerLogin{
  
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}
.login{
  width: 72px;
  height: 32px;
  display: inline-block;
  color: #fff;
  background: #0475D7;
  font-size: 16px;
  line-height: 32px;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
}
.banner{
  height: 204px;
  width: 100%;
  background-image: url("@/assets/img/banner@2x.png");
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 0;
}
::v-deep .banner .el-carousel__container{
  height: 204px;
}
.banner-img{
  width: 100%;
  height: 100%;
}
.main{
  background-image: url("@/assets/img/BG.png");
  background-size: 100% 100%;
  padding-top: 15px;
}
.main-contain{
  width: 1520px;
  margin: 0  auto;
}
.sales{
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.04);
  border-radius: 4px;
  margin-bottom: 15px;
  margin-top: -5px;
}
.sales-li{
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  height: 64px;
}
.sales-li .num{
  font-weight: 500;
  font-size: 24px;
  color: #0475D7;
  line-height: 36px;
  text-align: left;
  font-style: normal;
}
.sales-li .unit{
  font-size: 12px;
  color: #000000;
  line-height: 18px;
  font-weight: 400;
}
.sales-li .describe{
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 21px;
  margin-top: -7px;
}
.mokuai{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 14px;
}
.mokuai-li{
  width: 494px;
}
.title-name{
  font-weight: 800;
  font-size: 20px;
  color: #000000;
  letter-spacing: 5px;
}
.title-more{
  font-weight: 400;
  font-size: 14px;
  color: #013B86;
  float: right;
  cursor: pointer;
}
.mokuai-li-title {
  height: 45px;
  line-height: 45px;
}
.mokuai-li-title img{
  width: 25px!important;
  height: 25px!important;
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -5px;
}
.mokuai-li-main{
  border-radius: 4px;
}

.ptjs .mokuai-li-main{
  height: 264px;
  background: #fff;
}
.ptjs .ptjs-tab{
  display: flex;
  font-weight: 500;
  font-size: 18px;
  color: #0475D7;
  text-align: center;
  line-height: 37px;
  height: 37px;
}
.ptjs .ptjs-tab .tabli{
  width: 50%;
  background: #EDF6FF;
  color: #0475D7;
  cursor: pointer;
}
.ptjs .ptjs-tab .tabli{
  width: 33.333%;
}
.ptjs .ptjs-tab .tabli.active{
  background: linear-gradient( 180deg, #00B0F4 0%, #2D63E9 100%);
  color: #FFFFFF;
  border-radius: 4px 4px 0 0;
}
.ptjs .ptjs-img{
  text-align: center;
  
}
.ptjs .ptjs-img.active{
  
}
.ptjs-img-img{
	margin: 10px 0;width: 458px;height: 64px;scale: 50%;
}
.ptjs .ptjs-img ul{
  display: flex;
}
.ptjs .ptjs-img ul img{
  width: 56px;
  height: 56px;
  margin: 0 21px;
}
.xwzx .mokuai-li-main{
  background: #fff;
  height: 244px;
  padding: 10px;
}
.xwzx ul li{
  height: 52px;
  display: flex;
  justify-content: flex-start;
  background: linear-gradient( 180deg, #F1F5F8 0%, #E9EFFB 32%, #FFFFFF 100%);
  box-shadow: 0px 2px 4px 2px #EBF0F6, 0px 2px 4px 2px #EAEFF6;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.xwzx .date{
  width: 52px;
  height: 44px;
  color: #ffffff;
  background: #6273ef;
 
  text-align: center;
  padding-top: 8px;
  font-weight: 300;
}
.xwzx li:nth-child(2) .date{
  background: #22c378;
}
.xwzx li:nth-child(3) .date{
  background: #fa7f39;
}
.xwzx li:nth-child(4) .date{
  background: #2b84f6;
}
.xwzx .date .day{
  position: relative;
  margin-bottom: 4px;
}
.xwzx .date .day::after {
  position: absolute;
  content: "";
  width: 11px;
  height: 0.5px;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  bottom: -2px;
}
.xwzx .date .year{
  font-size: 12px;
}
.xwzx .text{
  flex: 1;
  width: 0;
  height: 43px;
  background: linear-gradient(180deg, #ffffff 0%, #f4faff 100%);
  box-shadow: 0px 3px 12px rgba(150, 186, 221, 0.3);
  border-radius: 0 4px 4px 0;
  padding: 8px 11px 0 10px;
  font-size: 16px;
  border: 1px solid transparent;
}
.xwzx .text a{
  color: #000;
}
.xwzx .text p:nth-child(2){
  font-size: 12px;
    letter-spacing: -0.165px;
    color: #787878;
    margin-top: 2px;
}
.text-overflow{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.cggg .mokuai-li-main{
  background: #fff;
  height: 244px;
  padding: 10px;
}
.cggg ul{
  padding: 0px;
}
.cggg-li{
  background: linear-gradient( 180deg, #F1F5F8 0%, #E9EFFB 32%, #FFFFFF 100%);
  box-shadow: 0px 2px 4px 2px #EBF0F6, 0px 2px 4px 2px #EAEFF6;
  border: 1px solid #FFFFFF;
  margin-bottom: 6px;
  height: 36px;
  line-height: 36px;
  box-sizing: border-box;
  position: relative;
}
.cggg-li p{
  padding-left: 35px;
  font-weight: 900;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  width: 252px;
  margin-right: 27px;
  cursor: pointer;

  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cggg-li::before{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  content: "";
  width: 14px;
  height: 14px;
  background: url("@/assets/img/zhishi.png") no-repeat center;
  background-size: 100%;
}
.cggg-li .statusStr{
  margin-right: 15px;
  width: 60px;
  height: 24px;
  display: inline-block;
  background: #F5FFFB;
  border-radius: 4px;
  border: 1px solid #BDF0D9;
  line-height: 24px;
  font-size: 12px;
  color: #20C378;
  text-align: center;
  position: relative;
  padding-left: 5px;
}
.cggg-li .statusStr::before{
  content: "·";
  position: absolute;
  font-size: 40px;
  left: 4px;

}
.cggg-li .statusStrGrey{
  color: #999999;
  background-color: #F8F8F8;
}
.cggg-li .dateStr{
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  text-align: center;
}

.shangcheng{

}
.shangcheng .mokuai-li-main.ZXSC{
  display: flex;
    justify-content: center;
    align-items: center;
    width: 494px;
    height: 62px;
    background: #fff;
}
//轮播
.hzds{
  padding: 10px;
  background-color: #fff;
}
.lunboLeft{
  width: 80px;
  height: 122px;
  display: inline-block;
}
.lunboLeft .lbleft > li {
  height: 30.5px;
  height: 61px;
  width: 100%;
  background-color: #fafafa;
  border-left: 1px solid #e4e4e4;
  border-bottom: 1px solid #e4e4e4;
  text-align: center;
  position: relative;
}
.lunboLeft .lbleft > li .rightJt {
  width: 9px;
  height: 10px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: -9px;
  margin: auto;
}
.lunboLeft .lbleft > li > a {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}
.lunboLeft .lbleft .lunboLeftHover {
  background: -webkit-gradient(linear, left top, left bottom, from(#38B0EF), color-stop(0%, #38B0EF), color-stop(100%, #3763E0), to(#3763E0));
  background: linear-gradient(180deg, #38B0EF 0%, #38B0EF 0%, #3763E0 100%, #3763E0 100%);
}

 .lunboRight {
  width: 393px;
  height: 122px;
  display: inline-block;
  overflow: hidden;
}
 .lunboRight .lbright {
  width: 1965px;
  margin-left: 0;
}
 .lunboRight .lbright li {
  width: 393px;
  height: 122px;
  display: inline-block;
  background-repeat: no-repeat;
  cursor: pointer;
  background-size: 100% 100%;
}


.ryq{
  
}
.ryq .mokuai-li-main{
  display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 10px 0;
}
.ryq img{
  width: 440px;
  height: 228px;
}
::v-deep .ryq .el-carousel--horizontal{
  width: 100%;
}

.qyhl{

}
.qyhl .mokuai-li-main{
  padding: 10px 10px 0;
  background: #fff;
  
}
.qyhl .qy{
  display: flex;
  justify-content: space-between;
}
.jianjie{
  width: 150px;
  height: 200px;
  background-image: url("@/assets/img/gss.png");
  background-size: 100% 100%;
}
.shanjiao{
  background-image: url("@/assets/img/shanjiao.png");
}
.kailuan{
  background-image: url("@/assets/img/kailuan.png");
}
.shanneng{
  background-image: url("@/assets/img/shanneng.png");
}

.jianjie .text1{
  width: 100%;
  height: 140px;
  padding-top: 60px;
  display: block;
  background: linear-gradient( 180deg, rgba(154,200,255,0.62) 0%, rgba(2,15,36,0) 100%);
}
.jianjie .text1 p{
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-weight: 900;
  background: rgba(17,73,134);
  font-size: 20px;
  opacity: 0.8;
}
.jianjie .text2{
  width: 120px;
  height: 181px;
  display: none;
  background: rgba(17,73,134);
  color: #fff;
  padding:  19px 15px 0;
  opacity: 0.8;
}
.text2 .text2-title{
  display: block;
  font-size: 20px;
  font-weight: 900;
}
.text2 .text2-content{
  width: 120px;
  height: 92px;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-top: 18px;
}
.text2 .text2-more{
  display: block;
  font-size: 14px;
  cursor: pointer;
}
.jianjie:hover .text1{
  display: none;
}
.jianjie:hover .text2{
  display: block;
}

.btText{
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  margin-top: 10px;
  padding-bottom: 10px;
}

.company{
  display: flex;
  justify-content: space-between;
}
.company-li{
  display: flex;
  width: 24%;
  height: 56px;
  align-items: center;
  justify-content:  flex-start;
  border-radius: 5px;
  cursor: pointer;
}
.company-li-logo{
  margin-right: 13px;
  margin-left: 20px;
}
.company-li-logo img{
  width: 48px;
  height: 25px;
}
.company-li-describe span{
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 21px;
  
}
.trans{
  text-transform: uppercase;
  transform-origin: left;
  white-space: nowrap;
  display: flex;
}
.company-li-describe span:nth-child(3){
  font-size: 12px;
}
.footerHtml{
  width: 100%;
  height: 36px;
  background: #002365;
  color: #fff;
  text-align: center;
  line-height: 36px;
  font-weight: 400;
  font-size: 12px;
}



//步骤条
::v-deep .el-step__icon.is-text{
  background-color: #4F9FF3;
  color: #fff;
}
::v-deep .el-step__title.is-finish{
  color: #000;
}
::v-deep .el-step__head.is-finish{
  color: #4F9FF3;
  border-color:#4F9FF3;
}
::v-deep .el-step.is-center .el-step__line{
  background-color: #4F9FF3!important;
}
@media screen and (min-width:1200px) and (max-width:1520px) {
  .main-contain{
    //scale: 79%;
    width: 1200px;
  }
  .ptjs .ptjs-img ul img{
    width: 35px;
    height: 35px;
  }
  .ptjs-img-img{
    margin: 8px 0;width: 390px;height: 64px;scale: 50%;
  }
  .mokuai-li{
    width: 390px;
  }
  .cggg-li p{
    width: 150px;
  }
  .shangcheng .mokuai-li-main.ZXSC{
    width: 390px;
  }
  .lunboLeft{
    width: 67px;
  }
  .lunboRight{
    width: 303px;
  }
  .lunboRight .lbright li{
    width: 303px;
  }
}

.queryview1{width:100%;height:100%;display:flex;flex-direction: column}
.queryview1-top{width:100%;height:37px;display:flex;background:#EDF6FF;border-radius:5px 5px 0 0}
.queryview1-cent{width:100%;flex:1;border-radius:0 0 5px 5px;background:#fff;padding:8px 10px;box-sizing:border-box;}
.query1-neirong{width:100%;height:100%;}
.queryview1-link{width:50%;height:37px;line-height:37px;text-align:center;font-size:18px;font-weight:500;color:#0475D7;cursor:pointer;}
.queryview1-link.active{color:#fff;background: linear-gradient(180deg, #00B0F4 0%, #2D63E9 100%);border-radius:5px 5px 0 0;}
</style>
